import { render, staticRenderFns } from "./mySubTable.vue?vue&type=template&id=396dba76&"
import script from "./mySubTable?vue&type=script&lang=js&"
export * from "./mySubTable?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports